import { footerLinkStyle } from "@/styles/sharedStyle";
import { Font, Icon } from "@moneyforward/mfx_biz_react_components";

export const ExternalToolsUsageLink = () => {
  return (
    <>
      <a
        href="https://corp.moneyforward.com/privacy/external-tools/"
        css={footerLinkStyle}
        target="_blank"
      >
        <Font variant="m" component="span">
          外部送信ツールに関する公表事項
        </Font>
      </a>
    </>
  );
};
